export default __webpack_public_path__ + "static/media/logo.6926a13d.png";